/* RESPONSIBLE TEAM: team-phone */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'sms/sms_verification_form';
  },
});
